// extracted by mini-css-extract-plugin
export default {"maint":"slaiderch_maint__+1FQ5"};